export * from './types';

import { TurnstileCaptcha } from './TurnstileCaptcha';
import { CaptchaFC } from './types';

/*
Disabled as Redux is not available in the login page to check for Feature flags.
We need to check how we can be able to check for Feature flags in the login page.

import React from 'react';
import { connect } from 'react-redux';

import { isFeatureEnabled } from 'common/trunk-features/store/selectors';

import { CaptchaFC, CaptchaProps } from './types';
import { DisabledCaptcha } from './DisabledCaptcha';

const mapStateToProps = (state) => ({
  isEnabled: isFeatureEnabled(state, 'SOAI-471-turnstile-captcha'),
});

export const Captcha: CaptchaFC = (connect(mapStateToProps)(
  (props: CaptchaProps & { isEnabled: boolean }) => {
    const { isEnabled } = props;
    return isEnabled ? <TurnstileCaptcha {...props} /> : <DisabledCaptcha {...props} />;
  },
) as unknown) as CaptchaFC;
*/
export const Captcha: CaptchaFC = TurnstileCaptcha;
